<div class="container">
    <h2 class="text-danger">Access Denied</h2>
    <p>
        You currently don't have access to the TimeSheet app.
        To gain access, please ask your manager or supervisor to send a request to Help Desk at <a
            href="mailto: helpdesk@dnv.org">helpdesk@dnv.org</a>, specifying which of the following groups you need to
        be a member of.
    </p>
    <table class="table">
        <thead>
            <tr>
                <th>Group membership</th>
                <th>Common tasks</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>Staff</td>
                <td>Fill out personal timesheets</td>
            </tr>
            <tr>
                <td>Manager</td>
                <td>Review and approve timesheets</td>
            </tr>
            <tr>
                <td>Timekeeper</td>
                <td>Review and process time entries to JDE</td>
            </tr>
            <tr>
                <td>Human Resources</td>
                <td>Update stat holiday calendar</td>
            </tr>
        </tbody>
    </table>
</div>